import React from "react";
import styled from "styled-components";
import {NextSeo} from "next-seo";

import Page from "../../../components/Page";
import {works_list} from "../../../api/works";
import WorkItem from "../../../components/WorkItem";
import Link from "next/link";
import t from "../../../utils/locale";
import {withRouter} from "next/router";

const Container = styled.div`
  width: 100%;
  padding: 1rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
`;

const WorkList = styled.div`
  width: 100%;
  padding: 1rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const MenuContainer = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 0;
  justify-content: center;
  align-items: center;
`;

const MenuItem = styled.li`
  margin: 0 0.75rem;
  text-transform: uppercase;
  font-size: 0.75rem;
  position: relative;

  a {
    transition: border-bottom 0.3s;
    text-decoration: inherit;
    border: none;
    color: inherit;

    &:hover {
      border-bottom: solid 2px #333;
    }
  }
`;

class Works extends React.Component {
  render() {
    const current_language = this.props.router.locale;

    return (
      <Page>
        <NextSeo title="Works" description="Works." />

        <Container>
          <MenuContainer>
            <MenuItem>
              <Link href={"/works/category/all"}>{t(current_language, "All")}</Link>
            </MenuItem>
            <MenuItem>
              <Link href={"/works/category/residential"}>
                {t(current_language, "Residential")}
              </Link>
            </MenuItem>
            <MenuItem>
              <Link href={"/works/category/public"}>{t(current_language, "Public")}</Link>
            </MenuItem>
          </MenuContainer>

          <WorkList>
            {this.props.works.map(work => (
              <WorkItem key={work.id} work={work} />
            ))}
          </WorkList>
        </Container>
      </Page>
    );
  }
}

export async function getServerSideProps(context) {
  try {
    const {category} = context.query;
    const language = context.locale || "en";
    const res = await works_list(category, language);
    const works = res.results || [];

    return {
      props: {
        works,
      },
    };
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export default withRouter(Works);
